import { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis
} from "recharts";
import { eur } from "../../../utils/eur";
import InfoTip from "../../ui/InfoTip";
import SpinnerLoader from "../../ui/SpinnerLoader";

const ROW_HEIGHT = 36;

const CreditBars: FC<{
  title: string;
  info: string;
  data: { name: string; value: number }[];
  loading?: boolean;
  color?: string;
  className?: string;
}> = ({ title, info, data, loading, color = "#3A81F6", className }) => {
  const rows = [...data].sort((a, b) => b.value - a.value);
  const total = rows.reduce((sum, r) => sum + r.value, 0);

  return (
    <div className={`bg-white border border-gray-200 rounded-lg px-6 py-4 flex flex-col ${className ?? ""}`}>
      <div className="flex items-center gap-1">
        <p className="text-xs uppercase leading-6 font-medium text-neutral">
          {title}
        </p>
        <InfoTip text={info} className="w-3.5 h-3.5" />
      </div>
      {loading ? (
        <div className="h-6 w-20 bg-gray-200 rounded-md animate-pulse" />
      ) : (
        <p className="text-sm leading-6 font-bold">{eur(total)}</p>
      )}
      <div
        className="relative mt-3"
        style={{ height: Math.max(rows.length, 1) * ROW_HEIGHT + 8 }}
      >
        {loading ? (
          <SpinnerLoader className="inset-0 h-max m-auto absolute" />
        ) : null}
        {!loading && rows.length > 0 && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} layout="vertical" margin={{ right: 64 }}>
              <CartesianGrid strokeDasharray="4" stroke="#EAEAEA" horizontal={false} />
              <XAxis type="number" hide />
              <YAxis
                type="category"
                dataKey="name"
                axisLine={false}
                tickLine={false}
                fontSize={12}
                color="#6E6E6E"
                width={150}
              />
              <Bar dataKey="value" fill={color} radius={[0, 4, 4, 0]} barSize={14}>
                <LabelList
                  dataKey="value"
                  position="right"
                  fontSize={12}
                  fill="#2C2C2C"
                  formatter={(v: number) => eur(v)}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default CreditBars;
